import type { MetaFunction } from "@remix-run/node";
import { getSeoMeta } from "~/utils/seo-meta";
import { SEOLayout } from "~/components/seo/SEOLayout";
import { IndustrySeoPage } from "~/components/seo/IndustrySeoPage";
import { INDUSTRY_SEO_CONFIG } from "~/utils/seo-industry-content";

export const meta: MetaFunction = () => {
  const content = INDUSTRY_SEO_CONFIG["food-beverage"];
  return getSeoMeta({
    title: content.title,
    description: content.description,
    url: "/for/food-beverage",
  });
};

export default function ForFoodBeverage() {
  return (
    <SEOLayout>
      <IndustrySeoPage content={INDUSTRY_SEO_CONFIG["food-beverage"]} />
    </SEOLayout>
  );
}
